// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__h7nF0","main_container":"Layout_main_container__ObfSL"};